import Http from '../containers/App/Http';

const AuthCheck = async () => {
     // CHECK THE AUTHENTICATION TO MAKE SURE A USER IS AUTH BEFORE VIEWING ANYTHING
    return await Http.post("auth/authCheck");
};

export default AuthCheck;